export default function debugLogger() {

  // this debugLog can be switched on with debugLog() in the browser console

  // developers add debugLog( 'message', 'object or message'); to their code

  // use debugLog with moderation as log's add to compiled code bloat.

  // set debugLog function globally
  window.debugLog = function(message, data) {
    if (sessionStorage.getItem('frontendDebug') == 'true' && (message)) {
      let messageText = ((message && message !== undefined) ? message.toString() : '');
      console.log('🦕frontendDebug ' + messageText, data || '');
    } else if (!message && !data) {
      // switch debug on if empty arguments
      // to store set // sessionStorage.setItem("frontendDebug", "true");
      sessionStorage.setItem("frontendDebug", "true");
      console.log('debugLog set to ON. To switch OFF clear session storage.');
    }
  }


}
